import { render, staticRenderFns } from "./CustomVBUploader.vue?vue&type=template&id=46d05286&scoped=true"
import script from "./CustomVBUploader.vue?vue&type=script&lang=ts"
export * from "./CustomVBUploader.vue?vue&type=script&lang=ts"
import style0 from "./CustomVBUploader.vue?vue&type=style&index=0&id=46d05286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d05286",
  null
  
)

export default component.exports